const parametrizationCurveStoretHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false
      }
    ]
  },
  {
    group: 'Loja',
    columns: [
      {
        name: 'Id',
        id: 'loja-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'loja-desc',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Id',
        id: 'produto-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'produto-desc',
        show: true
      }
    ]
  },
  {
    group: 'Data',
    columns: [
      {
        name: 'Inicio',
        id: 'date-init',
        show: true
      },
      {
        name: 'Fim',
        id: 'date-end',
        show: true
      },
      {
        name: 'Próxima Atualização',
        id: 'date-next',
        show: true
      }
    ]
  },
  {
    group: 'Configuração',
    columns: [
      {
        name: 'Nome',
        id: 'config-nome',
        show: true
      },
      {
        name: 'Data',
        id: 'criado-em',
        show: true
      }
    ]
  }
]

export default parametrizationCurveStoretHeader
